import { Component, input, OnDestroy, OnInit, output } from '@angular/core';
import { debounceTime, distinctUntilChanged, map, Subject } from 'rxjs';

@Component({
  selector: 'im-search-input',
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent implements OnInit, OnDestroy {
  public search: string = '';
  public search$ = new Subject<typeof this.search>();

  disabled = input<boolean>(false);
  onSearch = output<string>();

  ngOnInit(): void {
    this.search$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        map((search: string) => search.toLowerCase().trim())
      )
      .subscribe({
        next: (search: string) => {
          this.onSearch.emit(search);
        },
      });
  }
  ngOnDestroy(): void {
    this.search$.unsubscribe();
  }

  public trigger(): void {
    this.search$.next(this.search);
  }
}
